import React, { useCallback, useEffect } from "react";
import { Box, Layer, Text } from "grommet";
import { observer } from "mobx-react";
import "./CallNotification.css";
import { useStore } from "../../../../../../Hooks/useStore";
import Bell from "../../../../../../assets/bell.png";
import Accept from "../../../../../../assets/answer.png";
import Logo from "../../../../../../assets/skallicalling.png";
import Decline from "../../../../../../assets/phone_hover.png";
import sound from "../../../../../../Audio/call-ring.mp3";
import { handleAcceptCallClick } from "../../../../VideoOnNotification/VideoCallOnNotification";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import { MedicalEmergencyHelper } from "../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { NotificationHelper } from "../../../../../../util/notification/NotificationHelper";
import { useUser } from "../../../../context/User/UserContext";
import { EndpointService } from "../../../../../../services/endpoint/endpoint.service";
import usersService from "../../../screens/IAM/Users/users.service";
import { APIs } from "../../../../../../util/api/APIs";

export const CallNotification = observer(() => {
  const { rootStore } = useStore();
  const { setUser, user } = useUser();

  const ringtone = new Audio(sound);
  ringtone.loop = true;

  const playSound = () => {
    ringtone.play();
  };
  useEffect(() => {
    if (rootStore.callingStore.getShow) {
      playSound();
    }
    // else
    // {
    //   pauseSound();
    //   console.log('sound pause');
    // }
  }, [rootStore.callingStore, rootStore.callingStore.getShow]);

  useEffect(() => {
    if (rootStore.callingStore.getPauseDecline) {
      console.log("Pause Decline is TRUE, reloading the page.");
  
      // Reload the page
      pauseSound();
      window.location.reload();
  
      // After reload, set getPauseDecline to false
      rootStore.callingStore.setPauseDecline(false);
    }
  }, [rootStore.callingStore, rootStore.callingStore.getPauseDecline]); // Dependency array ensures this runs when getPauseDecline changes
  

  const notifyUsers = useCallback(
    async (sentBy, messageContent, name, usertype, id) => {
      console.log("sentBy, messageContent, id", sentBy, messageContent, id);
      const notificationHelper = new NotificationHelper();
      const medicalEmergencyHelper = new MedicalEmergencyHelper();

      console.log("notificationHelper", notificationHelper);
      console.log("medicalEmergencyHelper", medicalEmergencyHelper);
      let users = [];
      let usernames = [];
      let cognitoCrewUserId = null;
      let emsName = null;

      if (usertype == "ems") {
        console.log("emsName", name);
        if (name) {
          console.log("emsName inside if block", name);
          usernames.push(name);
        }
        if (usernames.length != 0) {
          console.log("send notification to web");
          try {
            await EndpointService.notifyWebUser(
              sentBy,
              messageContent,
              usernames
            );
          } catch (error) {
            console.log("Error in send web notification.", error);
            return true;
          }
        }
      }

      if (usertype == "crew") {
        cognitoCrewUserId = await medicalEmergencyHelper.findCrew(id);
        console.log("cognitoCrewUserId", cognitoCrewUserId);
        if (cognitoCrewUserId) {
          console.log("cognitoCrewUserId inside if block", cognitoCrewUserId);
          users.push(cognitoCrewUserId);
        }
        if (users.length != 0) {
          console.log("send notification to app");
          try {
            notificationHelper.sendNotification(sentBy, messageContent, users);
          } catch (error) {
            console.log("Error in send app notification.", error);
            return true;
          }
        }
      }
      return true;
    },
    [user]
  );

  // const pauseSound1 = async () => {
  //   ringtone.pause();
  //   ringtone.loop = false;
  //   ringtone.currentTime = 0;
  // };

  const pauseSound = async () => {
    console.log("yes it is called")
    ringtone.pause();
    ringtone.loop = false;
    ringtone.currentTime = 0;
    rootStore.callingStore.resetNotification();
  };

  const getMedical = async (medicalId) => {
    if (medicalId) {
      const medicalEmergencyFromAPI =
        await MedicalEmergencyService.getMedicalEmergency(medicalId);
      rootStore.emsStore.handleSelectedEmergency(medicalEmergencyFromAPI);
    }
  };

  return (
    <>
      {rootStore.callingStore.getShow && (
        <Layer
          position="center"
          modal={false}
          margin={{ vertical: "medium", horizontal: "medium" }}
          responsive={false}
          plain
          className="success-msg-main1"
        >
          <Box align="center" direction="column" gap="small" justify="between">
            <Box direction="column" align="center">
              {/* Logo Image */}
              <Box className="call-logo-circle">
                <img src={Logo} alt="logo" style={{ height: 40 }} />
              </Box>
              <Box
                direction="row"
                align="center"
                justify="start"
                style={{ marginTop: 15, width: 340}}
              >
                <div className="bell-icon-circle">
                  <img src={Bell} alt="bell icon" />
                </div>
                <Box style={{width: 280}}>
                  <Text className="crewname">
                    Call Initiated by Flight {rootStore.callingStore.FlightId} Crew: {rootStore.callingStore.getCrewname}
                  </Text>
                  <Text className="title">...is calling now</Text>
                </Box>
              </Box>
            </Box>
            <Box className="call-btn-group" direction="row">
              <button
                onClick={() => {
                  handleAcceptCallClick(
                    rootStore.callingStore.EmergencyId,
                    rootStore.callingStore.FlightId,
                    getMedical,
                    rootStore
                  );
                  pauseSound();
                }}
                className="accept-btn"
              >
                <img
                  src={Accept}
                  alt="accept call icon"
                  style={{height: 16, marginRight: 10}}
                  />
                Accept
              </button>
              <button
                onClick={async () => {
                  let token;
                  try {
                    let response = await MedicalEmergencyService.getFcmToken();
                    token = response.split("Access Token: ")[1];
                    console.log("FCM token response", token);
                  } catch (error) {
                    console.log("Error fetching FCM token", error);
                  }
                  if (token) {
                    let crewRecord;
                    try {
                      const medicalEmergencyHelper =
                        new MedicalEmergencyHelper();
                      let cognitoUserIdCrew =
                        await medicalEmergencyHelper.findCrewName(
                          rootStore.callingStore.EmergencyId
                        );
                      console.log("cognitoUserIdCrew", cognitoUserIdCrew);
                      if (cognitoUserIdCrew) {
                        await usersService
                          .listUsersByUsername(cognitoUserIdCrew)
                          .then((res) => {
                            crewRecord = res;
                          })
                          .catch((error) => {
                            console.log("Error fetching crew record", error);
                          });
                      }
                    } catch (error) {
                      console.log("Error fetching crew name", error);
                    }
                    console.log("crew user records", crewRecord);
                    if (crewRecord && crewRecord[0]["custom:fcmtoken"]) {
                      console.log(
                        'crewRecord[0]["custom:fcmtoken"]',
                        crewRecord[0]["custom:fcmtoken"]
                      );
                      let headersList = {
                        "Content-Type": "application/json",

                        Authorization: `Bearer ${token}`,
                      };

                      let bodyContent = JSON.stringify({
                        validate_only: false,

                        message: {
                          token: crewRecord[0]["custom:fcmtoken"],

                          data: {
                            type: "VoiceCallEnded",
                            flight_id: rootStore.callingStore.FlightId,
                            emergency_id:
                              rootStore.callingStore.EmergencyId?.toString(),
                            content_available: "true",
                          },
                        },
                      });
                      try {


                         let mesagesendurl;
                                if (APIs.BASE_URL.indexOf("sbx") >= 0) {
                                  mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
                                } else if (APIs.BASE_URL.indexOf("poc") >= 0) {
                                  mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
                                } else {
                                  mesagesendurl = "https://fcm.googleapis.com/v1/projects/skali-inc/messages:send";
                                }
                                
                        let response = await fetch(
                          mesagesendurl,
                          {
                            method: "POST",

                            body: bodyContent,

                            headers: headersList,
                          }
                        );

                        let data = await response.text();

                        console.log(data);
                      } catch (error) {
                        console.error("Call Api error", error);
                      }
                    }
                  }
                  if (rootStore.callingStore.EmergencyId) {
                    const [id, name, type] =
                      rootStore.callingStore.EmergencyId.split("#");
                    console.log("id", id, name, type);
                    await notifyUsers(
                      user?.username,
                      "Decline Call",
                      name,
                      type,
                      id
                    );
                  }
                  pauseSound();
                }}
                className="decline-btn"
              >
                <img
                  src={Decline}
                  alt="decline call icon"
                  style={{height: 16, marginRight: 10}}
                  />
                Decline
              </button>
            </Box>
          </Box>
        </Layer>
      )}
    </>
  );
});
